import { styled } from '@mui/material/styles'
import Divider from '@mui/material/Divider'

const StyledDivider = styled(Divider)({
  marginTop: 30,
  marginBottom: 30,
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '75%',
  backgroundColor: 'rgba(0,0,0,0.22)',
})

export default StyledDivider
